export default __webpack_public_path__ + "static/media/image-2.484f6c1e.jpg";